module.exports = __webpack_public_path__ + "img/right.f0439769.png";